import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import styles from './index.module.scss';
import Item from './Item/mavlink';

import AccordionCaret from '@/components/ui/AccordionCaret';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const cx = classNames.bind(styles);

const Items = ({ data: commands }) => {
  const [targetRobotId] = useSelector((state) => state.robot.targetRobotIds);
  const missionCurrent = useRobotTelemetry(targetRobotId, MESSAGE.MISSION_CURRENT);
  const [isExpanded, setExpanded] = useState(true);

  const toggleShow = () => {
    setExpanded(!isExpanded);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('header')} onClick={toggleShow}>
        <div className={cx('title')}>Commands</div>
        <AccordionCaret up={isExpanded} size={16} />
      </div>
      <div className={cx(['body', { expanded: isExpanded }])}>
        <div className={cx('inner')}>
          {commands.map((command, index) => {
            const label = index + 1;
            const isCurrent = missionCurrent?.seq === label;

            return <Item key={command.id} label={label} isCurrent={isCurrent} data={command} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Items;
